export default __webpack_public_path__ + "static/media/down_PC.a9367777.svg";